<script>
  import ReportItem from 'components/generator/ReportItem.svelte';
  import { generatorFiles } from 'constants';
  import { Tabs, Tab, TabList, TabPanel } from 'svelte-tabs';
</script>

<main>
  <div class="mx-2">  
    <h1 class="text-xl font-bold">
      Generator
    </h1>

    <Tabs>
      <TabList>
        <Tab>Sjabloon concept PV</Tab>
        <Tab>Tekstblokken</Tab>
      </TabList>
     
      <TabPanel>
        
        {#each generatorFiles as generatorCategory}
        <div class="mb-2">
          {#if generatorCategory.visible}
            <h1 class="font-bold">
              {generatorCategory.title}
            </h1>
            <div class="flex flex-wrap">
              {#each generatorCategory.reports as report}
              <div class="m-2">
                <ReportItem on:handleChoose {report} />
              </div>
              {/each}
            </div>
          {/if}
        </div>
        {/each}
      </TabPanel>
      <TabPanel>
        <div class="mb-2">
          Nog geen tekstblokken gevonden :-D
        </div>
      </TabPanel>
    </Tabs>
  </div>
</main>

<style>

</style>